import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space } = theme

const inset = '8.5rem'

export const Statistics = styled.section`
  width: 100%;
  overflow: hidden;
  background-color: ${colors['blue-background-strong-default']};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  padding: ${space['spacing-xl']} ${inset} ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-xxl']};
  }
`

export const Marquee = styled.div`
  width: 100vw;
  margin-left: calc(50% - 50vw);

  .swiper-slide {
    width: auto;
    height: auto;
  }

  .swiper-wrapper {
    align-items: center;
    transition-timing-function: linear !important;
  }
`

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['spacing-xxs']};
  padding: 0 ${space['spacing-xxl']};
  white-space: nowrap;
  text-align: center;

  @media (${media.phone}) {
    padding: 0 ${space['spacing-lg']};
  }
`
